export class TipoDte {
   public tipoDteId: string;
   public codigosii: number;
   public nombre: string;
   public descripcion: string;
   public abreviacion: string;
   public grupo: string;
}
